import { render, staticRenderFns } from "./OpenedList.vue?vue&type=template&id=1439368a&"
import script from "./OpenedList.vue?vue&type=script&lang=js&"
export * from "./OpenedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports